import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';

// RTLDE design spec has two color double-border
export const BORDER_WIDTH = {
  [HD]: 4,
  [FULL_HD]: 6,
};

export const BORDER_RADIUS = {
  [HD]: 4,
  [FULL_HD]: 4,
};

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);
